// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"7a63f278","386":"2e5b680f","598":"6fc93943","626":"d292ed44","818":"965fbd7c","873":"3a5cd2bc","983":"3b074d2b"}[chunkId] + ".chunk.js";
};